import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "hooks/AuthContext";
const CCRoute = ({ children }) => {
  const { user } = useAuth();
  console.log(user)
  // Check if the user is authenticated and has the "admin" role
  if (!user || !user.role.includes('cc')) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default CCRoute;
